import styled from "styled-components";

const ScreenTitle = styled.h1`
  position: absolute;
  text-align: center;
  /* Default ink for on-page titles (signup flow); the wave toolbar overrides
     this with the secondary-contrast ink (see WaveToolbar in ResonanceLayout). */
  color: var(--app-color-text, #393939);
  font-weight: bold;
  width: 80%;
  top: 40%;
  left: 10%;
  transform: translateY(-50%);
  margin: 0;

  /* No font-size below, so phones keep whatever h1 resolves to — which is
     Ionic's typography.css (1.625rem = 26px), NOT the UA 2em/32px. Getting that
     wrong once made this rule a no-op: 1.6rem = 25.6px is a 1.5% step off 26px.
     1.25rem = 20px is a real step for the laptop range, and stays under
     App.scss's desktop h1 (which this class rule outranks anyway). */
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

export default ScreenTitle;